import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface Role {
  id: number;
  code: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  permissionIds?: number[];
}

export interface Permission {
  id: number;
  code: string;
  module: string;
  action: string;
  description: string | null;
}

export const rolesApi = {
  async list(): Promise<Role[]> {
    const { data } = await apiClient.get<ApiSuccess<Role[]>>('/roles', { params: { limit: 100 } });
    return data.data;
  },
  async get(id: number): Promise<Role> {
    const { data } = await apiClient.get<ApiSuccess<Role>>(`/roles/${id}`);
    return data.data;
  },
  async create(input: { code: string; name: string; description?: string; permissionIds: number[] }): Promise<Role> {
    const { data } = await apiClient.post<ApiSuccess<Role>>('/roles', input);
    return data.data;
  },
  async update(id: number, input: { name?: string; description?: string; permissionIds?: number[] }): Promise<Role> {
    const { data } = await apiClient.put<ApiSuccess<Role>>(`/roles/${id}`, input);
    return data.data;
  },
  async listPermissions(): Promise<Permission[]> {
    const { data } = await apiClient.get<ApiSuccess<Permission[]>>('/permissions');
    return data.data;
  },
};
